import React from 'react';
import { Card, Spin } from 'antd';
import Carousel from 'react-alice-carousel';

import TitleTab from 'components/TitleTab';

import { RightCaret } from 'assets/svgs';

import Api from 'config/api';
import { getUnit } from 'utils/helpers';

import 'react-alice-carousel/lib/alice-carousel.css';
import './index.scss';

const KeyIndicators = () => {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [williams, setSwilliams] = React.useState([]);

  React.useEffect(() => {
    getKi();
    getComing();
  }, []);

  const getKi = async () => {
    setLoading(true);
    try {
      const { data } = await Api.get('website/get-KeyIndicator');
      setData(data?.data);
    } catch (error) {}
    setLoading(false);
  };

  const getComing = async () => {
    setLoading(true);
    try {
      const { data } = await Api.get('website/get-CbnIndicator');
      setSwilliams(data?.data);
    } catch (error) {}
    setLoading(false);
  };

  const renderCard = ({
    name,
    month,
    year,
    subIndicators,
    dataValue,
    item,
  }) => (
    <>
      {!loading && name ? (
        <Card className='key-indicator__card' data-value={dataValue}>
          <h1>{name}</h1>
          <p>{new Date(month).toDateString()}</p>
          <ul>
            {subIndicators.map((item, index) => (
              <li key={index}>
                <span>{item.name}</span>
                <span>{getUnit(item.unit, item.value)}</span>
              </li>
            ))}
          </ul>
        </Card>
      ) : null}
    </>
  );

  const responsive = {
    0: { items: 1 },
    568: { items: 2 },
    1024: { items: 2 },
    1330: { items: 3 },
  };
  const aliceItems = data?.map((item) =>
    renderCard({
      name: item[0].indicator,
      month: item[0].month,
      year: item[0].year,
      subIndicators: item.map((d) => ({
        name: d.subIndicator,
        value: d.value,
        unit: d.unit,
      })),
      item,
    })
  );

  const renderHorizontalCards = ({ cardItem }) => (
    <div className='horizontal-card'>
      <div>
        <h1 style={{ fontWeight: '700' }}>{cardItem.indicator}</h1>
        <p style={{ fontSize: '14px', fontWeight: '300' }}>
          {new Date(cardItem.date).toDateString()}
        </p>
      </div>
      <div className='horizontal-card__figure'>
        <h1>{getUnit(cardItem.unit, cardItem.value)}</h1>
        <RightCaret />
      </div>
    </div>
  );

  return (
    <Spin spinning={loading}>
      <div className='key-indicator'>
        <TitleTab title='Key Indicators' className='key-indicator__title' />
        <div className='key-indicator__carouselWrapper'>
          <Carousel
            responsive={responsive}
            mouseTracking
            items={aliceItems}
            disableDotsControls
            infinite
          />
        </div>
        <div className='summary'>
          {williams?.map((cardItem) => renderHorizontalCards({ cardItem }))}
        </div>
      </div>
    </Spin>
  );
};

export default KeyIndicators;
